const nextColumnName = (columnNumber) => {
  let columnName = [];

  while (columnNumber > 0) {
    let rem = columnNumber % 26;
    if (rem == 0) {
      columnName.push("Z");
      columnNumber = Math.floor(columnNumber / 26) - 1;
    } else {
      columnName.push(String.fromCharCode(rem - 1 + "A".charCodeAt(0)));
      columnNumber = Math.floor(columnNumber / 26);
    }
  }
  return columnName.reverse().join("");
};

const formatTime24to12 = (time24) => {
  if (!time24) return "";

  // Split "HH:MM:SS" or "HH:MM"
  const parts = time24.split(":");
  if (parts.length < 2) return time24;

  let hours = parseInt(parts[0], 10);
  const minutes = parts[1];
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 → 12

  return `${hours}:${minutes} ${ampm}`;
}

export { nextColumnName, formatTime24to12 };
